// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import { sharedPrintStyles } from "@keller/App/Components/Common/SharedPrintStyles";
import { pickUpLocationInfoDisplayStyles } from "@keller/Overrides/Widgets/CheckoutReviewAndSubmit/PickUpLocation";
import { hideElementOnPrint, mergeWithCss } from "@keller/XDL/Utilities";
import { css } from "styled-components";

pickUpLocationInfoDisplayStyles.labelName = {
    headingTextGridItem: {
        css: css`
            ${hideElementOnPrint}
        `,
    },
};

pickUpLocationInfoDisplayStyles.mainContainer = {
    ...sharedPrintStyles.mainContainer,
};

pickUpLocationInfoDisplayStyles.addressGridWrapper = {
    ...sharedPrintStyles.addressGridWrapper,
};

pickUpLocationInfoDisplayStyles.billingAndPickUpSection = {
    css: css`
        @media print {
            ${GridOffset} {
                display: flex;
            }
        }
    `,
};

pickUpLocationInfoDisplayStyles.billingAddressInfoDisplayGridItem = {
    ...mergeWithCss(sharedPrintStyles.billingAddressGridItem, {
        printWidth: 4,
        css: css`
            @media print {
                &&& {
                    flex-grow: 1;
                }
            }
        `,
    }),
};

pickUpLocationInfoDisplayStyles.pickUpLocationAddressInfoDisplayGridItem = {
    ...mergeWithCss(sharedPrintStyles.billingAddressGridItem, {
        printWidth: 4,
        css: css`
            @media print {
                &&& {
                    flex-grow: 1;
                }
            }
        `,
    }),
};

pickUpLocationInfoDisplayStyles.orderConfirmationTotalItem = {
    ...mergeWithCss(sharedPrintStyles.orderConfirmationTotalGridItem, {
        css: css`
            &&& {
                padding-left: 25px;
            }
        `,
    }),
};

pickUpLocationInfoDisplayStyles.notesItem = {
    ...sharedPrintStyles.notesGridItem,
};

pickUpLocationInfoDisplayStyles.richContentOnPrintGridItem = {
    ...sharedPrintStyles.richContentOnPrintGridItem,
};

pickUpLocationInfoDisplayStyles.hideOnPrint = {
    ...sharedPrintStyles.hideOnPrint,
};

pickUpLocationInfoDisplayStyles.pickUpShippingAddressLocationAddressInfoDisplayGridItem = {
    ...mergeWithCss(sharedPrintStyles.billingAddressGridItem, {
        printWidth: 4,
    }),
};
